import { render, staticRenderFns } from "./AlumnosIngresantes.vue?vue&type=template&id=819dc57c&scoped=true&"
import script from "./AlumnosIngresantes.vue?vue&type=script&lang=js&"
export * from "./AlumnosIngresantes.vue?vue&type=script&lang=js&"
import style0 from "./AlumnosIngresantes.vue?vue&type=style&index=0&id=819dc57c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819dc57c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VDialog,VIcon,VSelect,VTextField})
